import { useLocation } from "react-router-dom";
import PanelShell from "./PanelShell";
import AreaGuard from "../routes/AreaGuard";
import { useAuthContext } from "../context/AuthProvider";
import { can, canEnterAdmin } from "../utils/access";

const PAGE_TITLES = {
    '/admin': 'Modelos',
    '/admin/usuarios': 'Usuarios',
    '/admin/gallery': 'Galería de la portada',
};

/**
 * Gestión del estudio: modelos, personas y contenido de la portada.
 *
 * Cada entrada aparece solo si su permiso la abre. Antes se ofrecían pantallas
 * que el backend rechazaba después con un 403 y una pantalla en blanco.
 */
export default function AdminLayout() {
    const { user } = useAuthContext();
    const { pathname } = useLocation();

    const sections = [
        {
            title: 'Administración',
            items: [
                can(user, 'view_models') && { to: '/admin', end: true, icon: 'fa-camera', label: 'Modelos' },
                can(user, 'view_clients', 'view_all_users') && { to: '/admin/usuarios', icon: 'fa-users', label: 'Usuarios' },
                can(user, 'manage_gallery') && { to: '/admin/gallery', icon: 'fa-images', label: 'Galería' },
            ],
        },
        {
            title: 'Ir al sitio',
            items: [
                { to: '/live', icon: 'fa-tower-broadcast', label: 'Salas en vivo' },
                { to: '/modelos', icon: 'fa-id-badge', label: 'Catálogo' },
                { to: '/', icon: 'fa-house', label: 'Portada' },
            ],
        },
    ];

    return (
        <AreaGuard allowed={canEnterAdmin}>
            <PanelShell sections={sections} title={PAGE_TITLES[pathname] ?? 'Panel de administración'} />
        </AreaGuard>
    );
}
